export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://staging.musicade.app';
export const MUSICADE_URL = process.env.REACT_APP_MUSICADE_EVENT_URL || 'https://web.staging.musicade.app';
export const MUSICADE_EVENT_URL = `${MUSICADE_URL}/events`;
export const MUSICADE_PROFILE_URL = (username: string) => `${MUSICADE_URL}/profile/${username}`;

export const PROFILE_URL = (username: string) => `/profiles/${username}/`;
export const USER_EVENTS_URL = (username: string) => `/profiles/${username}/events/`;

export const EVENTS_URL = '/events/';
export const PUBLIC_EVENTS_URL = '/public/events/';
export const PUBLIC_HOMEPAGE_URL = '/public/homepage/';
export const PUBLIC_EVENT_DETAIL_URL = (eventUuid: string) => `/public/events/${eventUuid}/`;
export const FEATURED_EVENT_URL = '/events/featured/';
export const TRENDING_EVENTS_URL = '/events/trending/';
export const WEEKEND_EVENTS_URL = '/events/weekend/';
export const FREE_EVENTS_URL = '/events/free/';

// Checkout endpoints
export const EMBEDDED_CHECKOUT_URL = (eventId: number) => `/events/${eventId}/embedded-checkout/`;
export const PUBLIC_CHECKOUT_URL = '/public/checkout/';
export const FREE_BOOKING_URL = (eventId: number) => `/events/${eventId}/free-booking/`;
export const CHECKOUT_SESSION_STATUS_URL = (sessionId: string) => `/event/checkout-session/${sessionId}/status/`;
export const PUBLIC_SESSION_STATUS_URL = (sessionId: string) => `/public/checkout/session/${sessionId}/status/`;
export const PAYMENT_RETURN_URL = '/payment-return/';

// Free Booking
export const FREE_BOOKING_ELIGIBILITY_URL = (eventUuid: string) => `/event/${eventUuid}/free-bookings/eligibility/`;
export const SUBMIT_FREE_BOOKING_URL = (eventUuid: string) => `/event/${eventUuid}/free-bookings/`;

// Promo codes
export const VALIDATE_PROMO_CODE_URL = (eventId: number) => `/event/${eventId}/promo-codes/validate/`;

// Session management
export const CHECK_ACTIVE_SESSION_URL = '/event/session/check-active-session/';
export const RESUME_SESSION_URL = (sessionId: string) => `/event/session/resume-checkout-session/${sessionId}/`;
export const CANCEL_ACTIVE_SESSION_URL = '/event/session/cancel-active-session/';
